import { Button } from "antd";
import { useState, type FC } from "react";
import { CloseOutlined } from "@ant-design/icons";
import { ReactComponent as ZonesIcon } from "../../assets/images/autozone-btn-layers.svg";
import AutozonesDrawer from "./components/AutozonesDrawer/index";

import { createPortal } from "react-dom";
import { useNewTrialState } from "../new-trail/hooks/NewTrialStateProvider";
import ZoneLoadingStatus from "./components/ZoneLoadingStatus";
import ZoneTooltip from "./components/ZoneTooltip";
/*
  autozones main component
 */
interface AutozonesComponentProps {
  onOpen?: () => void;
  onClose?: () => void;
  onClearSelection?: () => void;
  isSelected?: boolean;
}

const AutozonesComponent: FC<AutozonesComponentProps> = ({
  onOpen,
  onClose,
  onClearSelection,
  isSelected = false,
}) => {
  const { trialInfo } = useNewTrialState();

  const [visible, setVisible] = useState<boolean>(false);
  const fieldId: string = trialInfo.field_ids[0];
  const showDrawer = (): void => {
    setVisible(true);
    onOpen?.();
  };

  const handleClose = (value: boolean): void => {
    setVisible(value);
    if (!value) onClose?.();
  };

  return (
    <>
      <div>
        <div className="corner-btn">
          <div className="map-control-button-common">
            <ZoneTooltip type="generation">
              <Button
                aria-label="Open autozones"
                onClick={showDrawer}
                type="primary"
              >
                <ZonesIcon className={isSelected ? "active" : ""} />
              </Button>
            </ZoneTooltip>

            {(visible || isSelected) && (
              <Button
                aria-label="Close autozones"
                className="close-button"
                onClick={(e) => {
                  e.stopPropagation();
                  handleClose(false);
                  onClearSelection?.();
                }}
              >
                <CloseOutlined />
              </Button>
            )}

            {/* Render ZoneLoadingStatus at document body level so fixed positioning is relative to viewport */}
            {createPortal(
              <ZoneLoadingStatus type="processing" />,
              document.body
            )}
          </div>
        </div>
        {/* adding a portal so that this component renders higher up the component and relatvie to the .map div */}
        {createPortal(
          <AutozonesDrawer
            visible={visible}
            setVisible={handleClose}
            fieldId={fieldId}
            loading={true}
          />,
          document.getElementById("trial-map") ?? document.body
        )}
      </div>
    </>
  );
};

export default AutozonesComponent;
